import { jsx as _jsx } from "react/jsx-runtime";
import { Alert as MuiAlert } from '@mui/material';
export function Alert(props) {
    return _jsx(MuiAlert, Object.assign({}, props));
}
